

<div class="container text-center mb-5 pb-5">
    <div class="row mt-5 pt-5">
          <div class="col-12 card-body pt-5">
    <h1>Error 404</h1>
    <h4 class="card-text p-4">Page not found.</h4>
   
  </div>  
    </div>

</div>
<hr>